import LineGradient from "../components/LineGradient"
import useMediaQuery from "../hooks/useMediaQuery"
import { motion } from "framer-motion"

const MySkills = () => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 1060px)")

  return (
    <section id="skills" className="pt-10 pb-24">
        {/* header section and image section */}
        <div className="md:flex md:justify-between md:gap-16 mt-32">
            <motion.div
                className="md:w-1/3"
                initial="hidden"
                whileInView="visible"
                viewport={{once:true,amount:0.5}}
                transition={{duration:0.5}}
                variants={{
                    hidden: {opacity:0,x: -50},
                    visible: {opacity:1,x:0}
                }}
            >
                <p className="font-playfair font-semibold text-4xl mb-5">
                    MY <span className="text-[#929AAB]">SKILLS</span>
                </p>
                <LineGradient width="w-1/3" />
                <p className="mt-10 mb-7">                
                    Proficient frontend engineer, expert in UI/UX, responsive design, modern frameworks, and cross-browser compatibility.
                </p>
            </motion.div>

            <div className="mt-16 md:mt-0">
                {isAboveMediumScreens ? (
                    <div className="relative z-0 ml-20 before:absolute before:-top-10 before:-left-10 
                         before:w-full before:h-full before:border-2 before:border-[#929AAB] before:z-[-1]">
                         <img 
                             src="../assets/skills-image.png" 
                             alt="skills"
                             className="z-10"
                         />
                    </div>
                ):(
                <div>
                    <img 
                             src="../assets/skills-image.png" 
                             alt="skills"
                             className="z-10"
                         />
                </div>
                )}
            </div>
        </div>

        {/* skills */}
        <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 mt-16 gap-32">

            <motion.div
                className="md:w-100 mt-10"
                initial="hidden"
                whileInView="visible"
                viewport={{once:true,amount:0.5}}
                transition={{duration:0.5}}
                variants={{
                    hidden: {opacity:0,y: 50},
                    visible: {opacity:1,y:0}
                }}
                >       
                <div className="relative h-40">
                    <div className="z-10">
                        <p className="font-playfair font-semibold text-3xl mt-3">HTML / SASS</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">React</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">JavaScript</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">TypeScript</p>
                    </div>
                </div>
            </motion.div>
            
            <motion.div
                className="md:w-100 mt-10"
                initial="hidden"
                whileInView="visible"
                viewport={{once:true,amount:0.5}}
                transition={{delay: 0.2,duration:0.5}}
                variants={{
                    hidden: {opacity:0,y: 50},
                    visible: {opacity:1,y:0}
                }}
                >       
                <div className="relative h-40">
                    <div className="z-10">
                        <p className="font-playfair font-semibold text-3xl mt-3">Ant Design</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">Material UI</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">Java</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">Spring Boot</p>
                    </div>
                </div>
            </motion.div>
            
            <motion.div
                className="md:w-100 mt-10"
                initial="hidden"
                whileInView="visible"
                viewport={{once:true,amount:0.5}}
                transition={{delay: 0.4,duration:0.5}}
                variants={{
                    hidden: {opacity:0,y: 50},
                    visible: {opacity:1,y:0}
                }}
                >       
                <div className="relative h-40">
                    <div className="z-10">
                        <p className="font-playfair font-semibold text-3xl mt-3">Node JS</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">Axios</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">Git</p>
                        <p className="font-playfair font-semibold text-3xl mt-3">Agile</p>
                    </div>
                </div>
            </motion.div>
            
                
        </div>
          
    </section>
  )
}

export default MySkills